import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { Cookies } from "../../index.js";
import { useSelector, useDispatch } from 'react-redux';
import { alert_error, alert_success } from "../../AppContext";
import { update_services_categorys, update_discount_orders, update_services_orders, update_money_orders }
    from '../../order/orders/actions.js';


function Orders_scam({ isOpen, isOpen2, setIsOpen, setIsOpen2, set_id_categories3 }) {
    const [isDisabled, setIsDisabled] = useState(true);
    const [isDisabled2, setIsDisabled2] = useState(true);
    const [codeSnippet, setcodeSnippetd] = useState(`<div id="hustmedia"></div>
        <script src='https://hust.media/api/website/main.js?v=4&chedo=1'></script>`);
    const items = useSelector(state => state.items);
    const money_orders = useSelector(state => state.money_orders);
    const amount_orders = useSelector(state => state.amount_orders);
    const discount_orders = useSelector(state => state.discount_orders);
    const services_categorys = useSelector(state => state.services_categorys);
    const services_orders = useSelector(state => state.services_orders);

    const set_money_orders = (value) => {
        dispatch(update_money_orders(value));
    };
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const set_services_categorys = (value) => {
        dispatch(update_services_categorys(value));
    };
    const set_services_orders = (value) => {
        console.log(value);
        dispatch(update_services_orders(value));
    };
    // const handleFocus = () => {
    //     setIsOpen(true);
    //     console.log(123);
    // };

    const [categorys, set_categorys] = useState([
        {
            id: "",
            stt: "",
            name: "Please wait a moment 😊 đang tải dịch vụ",
            money: "",
            status: "show",
            content: "",
            servicecode: "",
        },
    ]);
    const handleFocus2 = () => {
        setIsOpen2(true);
        console.log(123);
    };

    // const handleBlur = () => {
    //     setIsOpen(false);
    // };
    const handleBlur2 = () => {
        setIsOpen2(false);
    };

    // const handleMenuOpen = () => {
    //     setIsOpen(true);
    // };

    const [selectedOption, setSelectedOption] = useState(null);

    const handleOptionChange = (event) => {
        setSelectedOption(event);  // Cập nhật state với mục đã chọn
        setIsOpen(false);
        const selectedOption = event.value;
        const selectedOptionok = services_categorys.find(
            (option) => option.id == selectedOption
        );
        set_services_orders(selectedOptionok);
        // console.log(selectedOptionok.id);
        set_id_categories3(selectedOptionok.id);
    };

    const handleMenuOpen2 = () => {
        setIsOpen2(true);
    };

    useEffect(() => {
        // dulieutaikhoan();
    }, []);

    const handleFocus = () => {
        setIsOpen(true);
        console.log(123);
    };

    const handleBlur = () => {
        setIsOpen(false);
    };

    const handleMenuOpen = () => {
        setIsOpen(true);
    };


    function get_info_category(category_pro) {
        const apikey = Cookies.get("apikey");
        axios
            .get("https://hust.media/api/scams_check/getservice/category.php", {
                params: {
                    apikey: apikey,
                    option_category: category_pro,
                }
            })
            .then((response) => xuly_category(response))
            .catch((error) => alert_error(error));
    };

    function xuly_category(response) {
        set_categorys(response.data);
        setIsDisabled2(false);
        // setIsOpen2(true);
    };
    function get_info_full() {
    //   set_id_categories3('');
    };


    const CustomOption2 = ({ innerRef, innerProps, data }) => (
        <div ref={innerRef} {...innerProps} className="flex items-center p-2">
            <img src={data.img} alt={data.label} className="w-7 h-7 mr-2" />
            <div className="text-base">{data.label}
            </div>
        </div>
    );
    // Component SingleValue tùy chỉnh sử dụng Tailwind CSS
    const CustomSingleValue2 = ({ innerRef, innerProps, data }) => (
        <div ref={innerRef} {...innerProps} className="flex items-center -mt-6" >
            <img src={data.img} alt={data.label} className="w-7 h-7 mr-2" />
            <div className="text-base">{data.label}
            </div>
        </div>
    );
    // Custom Option with scroll logic
    // Custom Option with scroll logic
    // Custom Option with scroll logic
    const CustomOption = ({ innerProps, data, isSelected }) => {
        const optionRef = useRef(null);

        useEffect(() => {
            if (isSelected && optionRef.current) {
                const container = optionRef.current.parentElement; // Parent element of the option
                const option = optionRef.current;

                // Calculate the scroll offset to center the option
                const containerHeight = container.clientHeight;
                const optionHeight = option.clientHeight;
                const optionTop = option.offsetTop;
                const scrollTop = container.scrollTop;

                // Calculate the center position
                const centerScrollTop = scrollTop + optionTop - (containerHeight / 2) + (optionHeight / 2);

                // Smoothly scroll to the center position
                const duration = 270; // Duration in ms
                const start = container.scrollTop;
                const distance = centerScrollTop - start;
                let startTime = null;

                const scrollStep = (timestamp) => {
                    if (!startTime) startTime = timestamp;
                    const progress = Math.min((timestamp - startTime) / duration, 1);
                    container.scrollTop = start + distance * progress;
                    if (progress < 1) {
                        requestAnimationFrame(scrollStep);
                    }
                };

                requestAnimationFrame(scrollStep);
            }
        }, [isSelected]);

        return (
            <div
                ref={optionRef}
                {...innerProps}
                className={`flex items-center p-2 ${isSelected ? 'bg-purple-300 text-white' : ''}`}
            >
                <div className="flex items-center">
                    <div className="w-7 h-5 -ml-7" />
                    <div className={`text-base text-left flex-1 ${isSelected ? '' : ''}`}>
                        <span className="text-xs">{data.value} </span>
                        {data.label}
                    </div>
                </div>
            </div>
        );
    };

    // Component SingleValue tùy chỉnh sử dụng Tailwind CSS
    const CustomSingleValue = ({ innerRef, innerProps, data }) => (
        <div ref={innerRef} {...innerProps} className="flex items-center -mt-6" >
            <div className="flex items-center">
                <div className="w-7 h-5 -ml-7" />
                <div className="text-base text-left flex-1">
                    <span className="text-xs">{data.value} </span>
                    {data.label}
                </div>
            </div>
        </div>
    );
    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#4A90E2' : state.isFocused ? '#f0f0f0' : 'white',
            color: state.isSelected ? 'white' : 'black',
            fontWeight: state.isSelected ? 'bold' : 'normal',
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
        menuPortal: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
    };
    const menuOverlayStyles = {
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
        menuPortal: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
    };
    const handleOptionChange2 = (event) => {
        setIsOpen2(false);
        const selectedOption = event.value;
        const selectedOptionok = categorys.find(
            (option) => option.id == selectedOption
        );
        console.log(selectedOptionok.category);
        // set_service(selectedOptionok.code);
        get_category_service(selectedOptionok.code);
    };
    function get_category_service(value) {
        const apikey = Cookies.get("apikey");
        axios
            .get("https://hust.media/api/scams_check/getservice/category.php", {
                params: {
                    apikey: apikey,
                    option_category: value
                }
            })
            .then((response) => xuly_category_service(response))
            .catch((error) => alert_error(error));
    };

    function xuly_category_service(response) {
        set_services_categorys(response.data);
        setIsDisabled(false);
        setIsOpen(true);
    };

    const set_discount_orders = (value) => {
        dispatch(update_discount_orders(value));
    };

    useEffect(() => {
        get_info_full();
        get_info_category('total');
    }, []);

    return (
        <>
            <div className="text-center justify-center text-sm">Chọn chuyên mục của bạn</div>
            <Select
                classNamePrefix="Chọn 1 lựa chọn"
                onFocus={handleFocus2}
                options={categorys.map((option) => ({
                    value: option.id,
                    label: option.name,
                    img: option.img // Thêm thuộc tính img cho tùy chọn
                }))}
                components={{ Option: CustomOption2, SingleValue: CustomSingleValue2 }} // Sử dụng Option và SingleValue tùy chỉnh
                menuIsOpen={isOpen2}
                isDisabled={isDisabled2} // Khi isDisabled là true, người dùng không thể chọn
                onBlur={handleBlur2}
                onMenuOpen={handleMenuOpen2}
                onChange={handleOptionChange2} // Use selectedOption.value to get the selected value
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={false}
                styles={menuOverlayStyles}
                menuPosition="fixed"
                menuPortalTarget={typeof document !== "undefined" ? document.body : null}
            />

            <div className="text-center justify-center text-sm">Chọn dịch vụ của bạn</div>
            <Select
                classNamePrefix="Chọn 1 lựa chọn"
                options={services_categorys.map((option) => ({
                    value: option.id,
                    label: option.name,
                    money: option.money,
                }))}
                styles={customStyles} // Áp dụng styles tùy chỉnh
                components={{ Option: CustomOption, SingleValue: CustomSingleValue }}
                menuIsOpen={isOpen}
                isDisabled={isDisabled}
                onBlur={handleBlur}
                onMenuOpen={handleMenuOpen}
                menuPlacement="auto" // Đặt menu để cuộn tự động
                onChange={handleOptionChange}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={false}
                value={services_categorys.find(option => option.value === selectedOption)} // Chọn đúng tùy chọn
                menuPosition="fixed"
                menuPortalTarget={typeof document !== "undefined" ? document.body : null}
            />
        </>
    );
}
export default Orders_scam;
